import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

const isPublic = window.location.pathname.startsWith("/p/");
const PublicQuotePage = lazy(() => import("@/pages/PublicQuotePage"));
const InternalRoot = lazy(() => import("@/InternalRoot"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>{isPublic ? <PublicQuotePage /> : <InternalRoot />}</Suspense>
  </React.StrictMode>,
);
